import React from 'react';
export function Footer() {
  return <footer className="w-full bg-pine" data-id="element-110" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-111" data-mp="3gezcj1s77n03">
        <h3 className="font-display text-3xl uppercase text-ember" data-id="element-112" data-mp="3ggka709t7m26">
          Ice Machine Diagnostic Pro
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-paper/70" data-id="element-113" data-mp="32m1c310wf4po">
          The Freeze-or-Harvest Field System — split first, then test, then
          fix it right.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-paper/70" data-id="element-114" data-mp="3uftpzyu3se5m">
          <a href="mailto:[SUPPORT_EMAIL]" className="hover:text-paper hover:underline" data-id="element-115" data-mp="36ms6hozeurf">
            [SUPPORT_EMAIL]
          </a>
          <a href="[INSTAGRAM_URL]" className="hover:text-paper hover:underline" data-id="element-116" data-mp="3qd6tvlqeg72m">
            [@handle]
          </a>
          <a href="[SITE_URL]" className="hover:text-paper hover:underline" data-id="element-117" data-mp="29yxbr9cr3ek8">
            [www.site.com]
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-paper/15 pt-5 text-xs leading-relaxed text-paper/50" data-id="element-118" data-mp="2ezl3jx8szzfi">
          Independent resource. Not affiliated with or endorsed by any ice
          machine manufacturer. Ice Machine Diagnostic Pro is a field reference
          that complements the manufacturer&apos;s service manual: always
          verify specs on the data plate or in the model&apos;s manual, follow
          lockout and electrical safety rules, and leave refrigerant work to
          certified technicians (EPA 608, F-Gas, ARCtick, ODS or your local
          equivalent). Cleaning and sanitizing frequencies follow the
          manufacturer&apos;s instructions and your local health authority. Not
          a certification or manufacturer training course. &copy; Ice Machine
          Diagnostic Pro 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}